import { extendTheme } from '@chakra-ui/react';
import { theme as defaultTheme } from '../default';

import {
    Breadcrumb,
    Button,
    Container,
    Divider,
    Drawer,
    FormLabel,
    Heading,
    Input,
    Modal,
    Switch,
    Tabs,
    Text,
    Textarea,
} from './components';
import { colors } from './colors';
import { DEFAULT_FONT, PAGE_BACKGROUND } from '../utils';

// extending default theme to apply new portal styling to chakra components
// @see https://chakra-ui.com/docs/theming/customize-theme
export const theme = extendTheme(
    {
        colors,
        components: {
            Breadcrumb,
            Button,
            Container,
            Divider,
            Drawer,
            FormLabel,
            Heading,
            Input,
            Switch,
            Text,
            Textarea,
            Tabs,
            Modal,
        },
        styles: {
            global: {
                fontFamily: DEFAULT_FONT,
                body: {
                    fontFamily: DEFAULT_FONT,
                    bg: PAGE_BACKGROUND,
                },
            },
        },
    },
    defaultTheme
);
